import React, { useState, useEffect } from 'react';
import ListadoCamasAvance from './ListadoCamasAvance';
import DetallesAplicacionDeRefuerzos from './DetallesAplicacionDeRefuerzos';

/**
 * 
 * @param {funcion} funcion Función a ejecutar cuando se haga click en un elemento de la lista, se enviará el indice y el elemento de la lista en el cual se pulsó
 * @param {Array} data Array de objetos con los datos a mostrar en la lista, debe tener la siguiente estructura: {camas_ocupadas: float, fertilizante_exacto: float, fertilizante_ceil: float, evapotranspiracion: string | float | null} 
 * @returns 
 */
const ListaReportesNETJET = (p) => {
    const actualizarPadre = p.actualizarPadre ?? (() => { });
    const funcion = p.funcion ?? (() => { });
    const fecha = p.fecha;
    const [data, setdata] = useState([]);
    const classheadTable = 'text-center text-adaptable bg-black text-white';
    const calssBodyTable = "text-center bg-black6 border-none border-bottom border-secondary text-bold";
    const [contenedorDetallesValvula, setcontenedorDetallesValvula] = useState(null);
    var counter = 0;
    const keyGen = () => { counter++; return counter + "lista keygen"; }

    useEffect(() => {
        setdata([...(p.data ?? [])]);
    }, [p.data]);

    return (
        <>
            <div className='w-100'></div>
            <div className='bw-1300 p-2 pt-0 round-m shadow border bg-white overflow mt-3' style={{ maxHeight: "75vh", }}>
                {
                    data.length > 0 && <table className='table table-sm table-bordered' key={keyGen()}>
                        <thead>
                            <tr>
                                <th scope='col' className={classheadTable + " round-top-left-m"}>VALVULA</th>
                                <th scope='col' className={classheadTable}>RANCHO</th>
                                <th scope='col' colSpan={2} className={classheadTable + " round-top-right-m"}>CAMAS TOTALES</th>


                            </tr>
                        </thead>
                        <tbody>
                            {data.map((fer, i) => <React.Fragment key={keyGen()}>
                                <tr className=''>

                                    <td className={calssBodyTable}>{fer.valvula}</td>
                                    <td className={calssBodyTable}>{fer.rancho}</td>
                                    <td className={calssBodyTable}>{fer.camas_ocupadas}</td>
                                </tr>
                                <tr>
                                    <td className='text-start bg-light round-bottom-m' colSpan={3}>
                                        <div className='row justify-content-evenly w-100 m-0 p-0'>
                                            <ListadoCamasAvance camas={fer.aplicacion.aplicaciones} valvula={fer.valvula_id} fecha={fecha} actualizarPadre={actualizarPadre} />
                                            <div className='w-100'></div>
                                            <button className='btn btn-sm  border round-xxl text-bold btn-light shadow bw-350 pt-0 pb-0'
                                                onClick={() => setcontenedorDetallesValvula(fer)}
                                            >Detalle de aplicaciones</button>
                                        </div>
                                        {/*<span className='text-bold me-2'>Camas:</span> {fer.camas}*/}
                                    </td>
                                </tr>
                                <tr>
                                    <td className='text-start p-4 border-none bg-white' colSpan={3}></td>
                                </tr>
                            </React.Fragment>
                            )}

                        </tbody>
                    </table>
                }
                {contenedorDetallesValvula && <DetallesAplicacionDeRefuerzos close={() => setcontenedorDetallesValvula(null)} data={contenedorDetallesValvula} />}
            </div>
            <div className='w-100'></div>

        </>

    )
}

export default ListaReportesNETJET;